export const LANGUAGES_PAIR = 'languages_pair';
